<template>
  <div class="content">
    <template>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <card>
                <template slot="header">
                  <h4 class="card-title">Clientes</h4>
                </template>

                <div class="ml-3 mb-4 mt-2">
                  <label for="perfil" class="mb-3">Filtros</label>
                  <div class="d-flex flex-column flex-sm-row">
                    <div
                      class="d-flex mr-0 mr-sm-3 mb-2 mb-sm-0 align-self-center"
                    >
                      <div class="d-flex pr-2 align-items-center">
                        <label for="perfil">Id</label>
                      </div>
                      <input v-model="clienteFiltros.id" class="form-control" />
                    </div>
                    <div
                      class="d-flex mr-0 mr-sm-5 mb-4 mb-sm-0 align-self-center"
                    >
                      <label
                        for="ativo"
                        class="d-flex align-items-center mb-0 pr-2"
                        >Nome</label
                      >
                      <input
                        v-model="clienteFiltros.nome"
                        class="form-control"
                      />
                    </div>
                    <div class="d-flex">
                      <button @click="loadList()" class="btn btn-success mr-2">
                        Filtrar
                      </button>
                      <button
                        @click="limparFiltrosEBuscarLista()"
                        class="btn btn-danger mr-2"
                      >
                        Limpar filtros
                      </button>
                      <router-link :to="`clientes-new`">
                        <button class="btn btn-success btn-fill">
                          Cadastrar Novo
                        </button>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="overflow-auto">
                  <l-table
                    class="table-hover table-striped"
                    :columns="dataTable.columns"
                    :data="dataTable.data"
                  >
                    <template slot-scope="{ row }">
                      <td>
                        <b>{{ row.codigo }}</b>
                      </td>
                      <td>
                        {{ row.nomeCompleto }}
                        <i
                          v-if="row.lembreteVencido"
                          class="fa fa-exclamation text-danger"
                        ></i>
                      </td>

                      <td>
                        <router-link :to="`clientes/${row.codigo}`">
                          <button
                            class="btn btn-icon btn-info"
                            style="margin-right: 10px"
                            @click="editar(row)"
                          >
                            <i class="fa fa-pencil"></i>
                          </button>
                        </router-link>

                        <button
                          class="btn btn-icon btn-danger"
                          style="margin-right: 10px"
                          @click="openModalDeletar(row)"
                        >
                          <i class="fa fa-trash-o"></i>
                        </button>
                        <!-- <router-link :to="`cliente-os/${row.codigo}`"> -->
                        <router-link
                          :to="{
                            name: 'FormularioCadastroOSCliente',
                            params: {
                              codigoCliente: row.codigo,
                              nomeCliente: row.nomeCompleto,
                              idCliente: row._id
                            }
                          }"
                        >
                          <button
                            class="btn btn-icon btn-primary"
                            style="margin-right: 10px"
                          >
                            <i class="fa fa-file-text"></i>
                          </button>
                        </router-link>
                        <router-link
                          :to="`financeiro-cliente/${row.codigo}`"
                          v-if="isAdministrador"
                        >
                          <button class="btn btn-icon btn-success">
                            <i class="fa fa-money"></i>
                          </button>
                        </router-link>
                      </td>
                    </template>
                  </l-table>
                </div>
                <v-pagination
                  v-if="dataTable.data.length > 0"
                  v-model="currentPage"
                  :page-count="totalPages"
                  :classes="bootstrapPaginationClasses"
                  :labels="paginationAnchorTexts"
                ></v-pagination>
              </card>
            </div>
          </div>
        </div>
      </div>
    </template>
    <Modal
      header="Deseja realmente excluir o cliente?"
      :hasBody="true"
      v-show="isVisibleModalDeletar"
      @close="closeModalDeletar"
      :hasDeleteButton="true"
      :deleteFunction="deletarLead"
    >
      <template v-slot:body>
        Esta ação é definitiva e não poderá ser desfeita.
      </template>
    </Modal>
  </div>
</template>
<script>
import _ from 'lodash';
import { VueTabs, VTab } from 'vue-nav-tabs';
import LTable from 'src/components/Table';
import DatePicker from 'vue2-datepicker';
import ClientesService from 'src/services/clientes';
import vPagination from 'vue-plain-pagination';
import VueToggles from 'vue-toggles';
import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import subDays from 'date-fns/subDays';
import Multiselect from 'vue-multiselect';
import Modal from 'src/components/Modal';
import PieChart from 'src/components/PieChart';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
import 'vue-nav-tabs/themes/vue-tabs.css';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const colunas = ['ID', 'Nome'];
export default {
  components: {
    LTable,
    vPagination,
    VueToggles,
    Modal,
    DatePicker,
    VueTabs,
    VTab,
    PieChart,
    Multiselect
  },
  mounted() {},
  data() {
    return {
      dataTable: {
        columns: [],
        data: []
      },
      isVisibleModalDeletar: false,
      isVisibleModalLembrete: false,
      isVisibleModalConverter: false,
      clienteSelecionado: {},
      currentPage: 1,
      totalPages: Number,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link btn-info'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      },
      clienteFiltros: {
        nome: '',
        id: ''
      }
    };
  },
  created() {
    this.loadList();
    this.dataTable.columns = colunas;
  },
  computed: {
    isAdministrador() {
      const userData = this.$store.state.usuario;
      return _.get(userData, 'tipoUsuario') === 'administrador';
    }
  },
  methods: {
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
      const params = {
        page: this.currentPage,
        nome: this.clienteFiltros.nome,
        id: this.clienteFiltros.id
      };
      ClientesService.listar(params)
        .then(response => {
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 10);
          this.dataTable.data = _.get(response, 'data.result');

          this.dataTable.columns = colunas;

          loader.hide();
        })
        .catch(error => {
          loader.hide();
          this.showError(error);
        });
    },

    showError(error) {
      const message =
        _.get(error, 'response.status') === 400 &&
        _.has(error, 'response.data.message')
          ? _.get(error, 'response.data.message')
          : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

      this.notifyVue(
        'top',
        'center',
        'danger',
        message,
        'fa fa-exclamation-triangle'
      );
    },
    openModalDeletar(row) {
      this.isVisibleModalDeletar = true;
      this.clienteSelecionado = row;
    },
    closeModalDeletar() {
      this.isVisibleModalDeletar = false;
      this.clienteSelecionado = {};
    },
    openModalConverter(row) {
      this.isVisibleModalConverter = true;
      this.clienteSelecionado = row;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    deletarLead() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Deletado com Sucesso.',
          'fa fa-check'
        );
        this.closeModalDeletar();
        this.loadList();
        loader.hide();
      };

      const errorCallback = err => {
        this.closeModalDeletar();
        loader.hide();
        this.showError(err);
      };

      ClientesService.deletar(this.clienteSelecionado)
        .then(sucessCallback)
        .catch(errorCallback);
    },
    limparFiltrosEBuscarLista() {
      this.clienteFiltros = {
        estado: '',
        ativo: false
      };
      this.loadList();
    },
    closeModalLembrete() {
      this.isVisibleModalLembrete = false;
      setTimeout(() => {
        this.clienteSelecionado = {};
        this.dataLembrete = null;
      }, 500);
    },
    closeModalConverter() {
      this.isVisibleModalConverter = false;
      this.clienteSelecionado = {};
    },
    openModalLembrete(row) {
      this.clienteSelecionado = row;
      if (row.dataLembrete) {
        this.dataLembrete = new Date(row.dataLembrete);
      }
      this.isVisibleModalLembrete = true;
    },
    salvarLembrete() {},
    disabledDateDatepickerDataLembrete(date) {
      const ontem = subDays(Date.now(), 1);
      return isBefore(date, ontem);
    },
    disabledDateDatepickerEstatistica(date) {
      return isAfter(date, Date.now());
    },
    isBefore(dataLembreteString) {
      if (!dataLembreteString) {
        return false;
      }
      const dataLembrete = new Date(dataLembreteString);
      return isBefore(dataLembrete, Date.now());
    },
    codigoENome(user) {
      return `${user.codigo} ${
        user.nome ? `${user.nome} ${user.sobrenome}` : user.razaoSocial
      }`;
    },
    converter() {}
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.loadList();
      }
    }
  }
};
</script>
<style>
.crm-tabs .nav {
  display: block !important;
}
.small {
  max-width: 600px;
  margin: auto;
}
.usuario-multiselect {
  min-width: 12em;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
